import React from "react";
import { Inline } from "slate";

export interface ISlateContext {
  linkInputOpen?: boolean;
  currentLinkNode?: Inline | null;
}

interface Props {
  children: React.ReactNode;
}

type IContextArgs = [ISlateContext, React.Dispatch<React.SetStateAction<ISlateContext>>];

// tslint:disable-next-line: no-empty
const SlateContext = React.createContext<IContextArgs>([{}, (() => { })]);

const SlateContextProvider = ({ children }: Props) => {
  const [state, setState] = React.useState<ISlateContext>({ linkInputOpen: false, currentLinkNode: null });
  return (
    <SlateContext.Provider value={[state, setState]}>
      {children}
    </SlateContext.Provider>
  );
};

export { SlateContext, SlateContextProvider };
